module.exports = __webpack_public_path__ + "img/red.be5030ca.webp";